module.exports = __webpack_public_path__ + "d3c70757403592c142c18dbf35ad3910.svg";